// extracted by mini-css-extract-plugin
module.exports = {"CanvasWrapper":"ClientCanvas_CanvasWrapper__Fp1TA","CanvasOverLayout":"ClientCanvas_CanvasOverLayout__eO_tS"};